import React from "react";
import { Redirect, withRouter } from 'react-router-dom'
import HelperGeneral from "../../helpers/HelperGeneral";
import UserInfo from "../auth/UserInfo";
class NotFound extends React.Component {

    constructor(props) {
        super(props);
        HelperGeneral.bodyAddClass('bg-purple', 'NotFound');
    }

    componentDidMount() {
        if (!UserInfo.isLogin()) {
            return HelperGeneral.pageChange("",'/login');
        }
    }


    render() {
        return (
            <div className="stars">
                <div className="central-body">
                    <img className="image-404" alt={'404'} src={require('../../assets/images/svg/404.svg').default} width={300}/>
                    <button
                        type={'button'}
                        onClick={() => {
                            HelperGeneral.bodyAddClass();
                            HelperGeneral.pageChange(this, '/');
                        }}
                        className="btn-go-home"
                    >
                        GO BACK HOME
                    </button>
                </div>
                <div className="objects">
                    <img className="object_rocket" src={require('../../assets/images/svg/rocket.svg').default} alt={'rocket'} width={40}/>
                    <div className="earth-moon">
                        <img className="object_earth" src={require('../../assets/images/svg/earth.svg').default} alt={'earth'} width={100}/>
                        <img className="object_moon" src={require('../../assets/images/svg/moon.svg').default} alt={'moon'} width={80}/>
                    </div>
                    <div className="box_astronaut">
                        <img className="object_astronaut" src={require('../../assets/images/svg/astronaut.svg').default} alt={'astronaut'} width={140}/>
                    </div>
                </div>
                <div className="glowing_stars">
                    <div className="star"></div>
                    <div className="star"></div>
                    <div className="star"></div>
                    <div className="star"></div>
                    <div className="star"></div>
                </div>

            </div>
        )
    }

}

export default withRouter(NotFound);
